import React, { Component } from 'react'
import { Route } from 'react-router';
import { connect } from 'react-redux';
import { ConnectedRouter, routerActions } from 'react-router-redux';

import Login from 'containers/login/Login';
import TracksTree from 'containers/tracks-tree/TracksTree';
import TracksTable from 'containers/tracks-table/TracksTable';
import TrackStatistics from 'containers/track-statistics/TrackStatistics';
import Settings from 'containers/settings/Settings';
import Calibrations from 'containers/calibrations/Calibrations';
import CalibrationForm from 'containers/calibration-form/CalibrationForm';
import Supervision from 'containers/supervision/Supervision';
import UsersTable from 'containers/users-table/UsersTable';
import UserActivity from 'containers/user-activity/UserActivity';
import UserForm from 'containers/user-form/UserForm';
import TrackEvents from 'containers/track-events/TrackEvents';
import TrackTemplates from 'containers/track-templates/TrackTemplates';
import TrackTemplateCreate from 'containers/track-template-create/TrackTemplateCreate';
import TrackTemplateUpdate from 'containers/track-template-update/TrackTemplateUpdate';
import TrackParams from 'containers/track-params/TrackParams';
import UploadingPreview from 'containers/uploading-preview/UploadingPreview';
import Chart from 'containers/chart/Chart';

class Router extends Component {
  constructor(props) {
    super (props);

    this.routes = [
      { isExact: false, path: '/login', component: Login },
      { isExact: true, path: '/', component: TracksTree },
      { isExact: false, path: '/tracks/tree', component: TracksTree },
      { isExact: false, path: '/tracks/table', component: TracksTable },
      { isExact: false, path: '/user-settings', component: Settings },
      { isExact: false, path: '/track-statistics', component: TrackStatistics },

      { isExact: true, path: '/calibrations/recorder-id/:recorderId/page/:page/page-size/:pageSize', component: Calibrations },
      { isExact: true, path: '/calibrations/recorder-id/:recorderId/page/:page', component: Calibrations },
      { isExact: true, path: '/calibrations/page/:page/page-size/:pageSize', component: Calibrations },
      { isExact: true, path: '/calibrations/recorder-id/:recorderId/page/:page', component: Calibrations },
      { isExact: true, path: '/calibrations/recorder-id/:recorderId', component: Calibrations },
      { isExact: true, path: '/calibrations', component: Calibrations },

      { isExact: true, path: '/calibration/update/:calibrationId', component: CalibrationForm },
      { isExact: true, path: '/calibration/create/recorder-id/:recorderId', component: CalibrationForm },
      { isExact: true, path: '/supervision/recorder-id/:recorderId/params-sourse/:paramsSource/recorder-template-id/:recorderTemplateId', component: Supervision },
      { isExact: true, path: '/supervision/recorder-id/:recorderId/params-sourse/:paramsSource/', component: Supervision },
      { isExact: true, path: '/supervision/recorder-id/:recorderId/', component: Supervision },
      { isExact: true, path: '/supervision/', component: Supervision },

      { isExact: true, path: '/users', component: UsersTable },
      { isExact: true, path: '/user/create/', component: UserForm },
      { isExact: true, path: '/user/:type/:userId', component: UserForm },
      { isExact: true, path: '/user-activity/:userId/page/:page/page-size/:pageSize', component: UserActivity },
      { isExact: true, path: '/user-activity/:userId/page/:page', component: UserActivity },
      { isExact: true, path: '/user-activity/:userId', component: UserActivity },

      { isExact: false, path: '/track-events/:trackId', component: TrackEvents },
      { isExact: true, path: '/track-templates/:trackId', component: TrackTemplates },
      { isExact: false, path: '/track-template-edit/create/track-id/:trackId/', component: TrackTemplateCreate },
      { isExact: false, path: '/track-template-edit/update/track-id/:trackId/template-id/:templateId', component: TrackTemplateUpdate },
      { isExact: false, path: '/track-params/:id', component: TrackParams },
      { isExact: true, path: '/uploading/:uploadingUid/recorder-id/:recorderId', component: UploadingPreview },
      { isExact: false, path: '/uploading/:uploadingUid/recorder-id/:recorderId/calibration-id/:calibrationId', component: UploadingPreview },
      { isExact: false, path: '/chart/track-id/:trackId/template-id/:templateId/from-frame/:fromFrame/to-frame/:toFrame', component: Chart }
    ];
  }

  componentWillUpdate() {
    // TODO: check if none pass and render NotFound
  }

  render() {
    return (<ConnectedRouter history={ this.props.history }><div>
        { this.routes.map((item, key) => {
          if (item.isExact) {
            return <Route exact path={ item.path } component={ item.component } key={ key } />
          }

          return <Route path={ item.path } component={ item.component } key={ key }/>
        }) }
      </div></ConnectedRouter>
    )
  }
};

function mapStateToProps(state) {
  return {
    location: state.router.location
  };
}

export default connect(mapStateToProps, () => { return {} })(Router);
